import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, withCtx as _withCtx, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

_pushScopeId("data-v-6d81e287")
const _hoisted_1 = { class: "token-select-input selected group selectable" }
const _hoisted_2 = { class: "text-base font-medium" }
const _hoisted_3 = { class: "flex items-center justify-between" }
const _hoisted_4 = { class: "flex items-center" }
_popScopeId()

import { computed, ref, toRef } from 'vue';
// Types
import { FullPool } from '@/services/balancer/subgraph/types';
import { TokenInfo } from '@/types/TokenList';
// Composables
import useTokens from '@/composables/useTokens';
import useWithdrawalState from '../composables/useWithdrawalState';
import { usePool } from '@/composables/usePool';

/**
 * TYPES
 */
type Props = {
  pool: FullPool;
  initToken?: string;
  tokenAddresses?: string[];
  changeType?: string;
  index: number;
};

/**
 * Props
 */

export default _defineComponent({
  props: {
    pool: { type: null, required: true },
    initToken: { type: String, required: false, default: '' },
    tokenAddresses: { type: Array, required: false },
    changeType: { type: String, required: false, default: '' },
    index: { type: Number, required: true, default: 0 }
  } as unknown as undefined,
  setup(__props: {
  pool: FullPool;
  initToken?: string;
  tokenAddresses?: string[];
  changeType?: string;
  index: number;
}) {

const props = __props


/**
 * STATE
 */
const selectedOption = ref(props.initToken);

/**
 * COMPOSABLES
 */
const { getTokens, getToken, nativeAsset } = useTokens();
const { isProportional, tokenOut, setBoostedOut } = useWithdrawalState(
  toRef(props, 'pool')
);
const { isWethPool, isStablePhantomPool, isWeightedBoostedPool } = usePool(
  toRef(props, 'pool')
);

const tokens = computed(() => getTokens(props.tokenAddresses || []));

const options = computed(() => {
  return props.tokenAddresses || [];
});

const selectedToken = computed((): TokenInfo => getToken(selectedOption.value));

const assetSetWidth = computed(
  () => 60 + ((props.tokenAddresses || []).length - 2) * 10
);

/**
 * METHODS
 */
function handleSelected(newToken: string): void {
  selectedOption.value = newToken;
  // tokenOut.value = newToken;
  setBoostedOut(props.index, newToken);
}

return (_ctx: any,_cache: any) => {
  const _component_BalAsset = _resolveComponent("BalAsset")!
  const _component_BalIcon = _resolveComponent("BalIcon")!
  const _component_BalDropdown = _resolveComponent("BalDropdown")!

  return (_openBlock(), _createBlock(_component_BalDropdown, {
    changeType: __props.changeType,
    options: _unref(options),
    minWidth: "44",
    onSelected: handleSelected
  }, {
    activator: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _createElementVNode("div", null, [
          _createVNode(_component_BalAsset, {
            address: _unref(selectedToken).address,
            class: "shadow mr-2"
          }, null, 8, ["address"])
        ]),
        _createElementVNode("span", _hoisted_2, [
          _createElementVNode("span", null, _toDisplayString(_unref(selectedToken).symbol), 1)
        ]),
        _createVNode(_component_BalIcon, {
          name: "chevron-down",
          size: "sm",
          class: "text-custom-blue-50 group-hover:text-pink-500 ml-2"
        })
      ])
    ]),
    option: _withCtx(({ option }) => [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _createVNode(_component_BalAsset, {
            address: option,
            class: "mr-2"
          }, null, 8, ["address"]),
          _createTextVNode(" " + _toDisplayString(_unref(tokens)[option]?.symbol), 1)
        ]),
        (selectedOption.value === option)
          ? (_openBlock(), _createBlock(_component_BalIcon, {
              key: 0,
              name: "check",
              class: "text-custom-blue-50 ml-2"
            }))
          : _createCommentVNode("", true)
      ])
    ]),
    _: 1
  }, 8, ["changeType", "options"]))
}
}

})